import { put, call, CallEffect, PutEffect, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { Action } from 'redux-saga';
import { setCustomer } from '@/redux/ducks/customer';
import { automaticApi } from '@/settings/api';
import { ReducersTypes } from '@/redux/reducers/Models';
import { mergeVehicleLists } from './utils';

export interface Fetch {
    callback?: (success: boolean) => void;
}

export interface GetVehiclesAction {
    type: string;
    payload: Fetch;
}

const uri = '/home-app/v1/init/userproduct';

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* getVehicles({
    payload,
}: GetVehiclesAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        yield put(setCustomer({ isLoadingVehicles: true }));

        const response = yield call(
            automaticApi.get,
            uri
        );

        // Combina veículos do CBILL (`listVehicle`) com os do serviço de
        // garagem do app (`listGarageVehicle`) em uma única lista.
        const vehicles = mergeVehicleLists(
            response?.data?.listVehicle,
            response?.data?.listGarageVehicle,
        );

        // Inicializa selectedVehicles com o primeiro veículo se não houver nenhum selecionado
        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);
        const shouldInitializeSelectedVehicles = (vehicles?.length ?? 0) > 0 &&
          (!customer?.selectedVehicles || customer.selectedVehicles.length === 0);
        
        yield put(
            setCustomer({
                isLoadingVehicles: false,
                products: response?.data?.products,
                vehicles: vehicles,
                ...(shouldInitializeSelectedVehicles && vehicles?.[0]?.plate && { selectedVehicles: [vehicles[0].plate] })
            })
        );
        if (payload?.callback) yield call(payload.callback, true);
    } catch (error) {
        yield put(setCustomer({ isLoadingVehicles: false }));
        if (payload?.callback) yield call(payload.callback, false);
    }
}